import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderby',
    pure: false
})
export class OrderByPipe implements PipeTransform {
    transform(array: Array<any>, args?: any) {
        let newDataArray: any = [];
        if (array.length > 0 && args.value != undefined) {
            for (let item of array) {
                newDataArray.push(item);
                //for (let subItem of item) {
                //     newDataArray.push(subItem);
                // }
            }
            newDataArray.sort((a: any, b: any) => {
                if ((a.firstName).toLowerCase() < (b.firstName).toLowerCase()) {
                    return -1 * args.direction;
                } else if ((a.firstName).toLowerCase() > (b.firstName).toLowerCase()) {
                    return 1 * args.direction;
                } else {
                    return 0;
                }
            });
            array = Array.from(newDataArray);
        }
        return array;
    }
}
